export class SituacoesETiposAnexoVO {

    constructor(
        public codigoPrestador?: string,
        public codigoBeneficiario?: string,
        public numeroGTO?: string
    ){}
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/situacoes-e-tipos-anexo.ts